import R01 from './reportsComponents/R01'
import R02 from './reportsComponents/R02'
import R03 from './reportsComponents/R03'
import R04 from './reportsComponents/R04'
import R05 from './reportsComponents/R05'
import R06 from './reportsComponents/R06'
import R07 from './reportsComponents/R07'
import R08 from './reportsComponents/R08'
import R09 from './reportsComponents/R09'
import R10 from './reportsComponents/R10'
import R11 from './reportsComponents/R11'
import R12 from './reportsComponents/R12'
import R13 from './reportsComponents/R13'
import R14 from './reportsComponents/R14'
import R15 from './reportsComponents/R15'
import R16 from './reportsComponents/R16'
import R17 from './reportsComponents/R17'
import R18 from './reportsComponents/R18'
import R19 from './reportsComponents/R19'
import R20 from './reportsComponents/R20'
import R21 from './reportsComponents/R21'
import R22 from './reportsComponents/R22'
import R23 from './reportsComponents/R23'
import R24 from './reportsComponents/R24'
import R25 from './reportsComponents/R25'
import R26 from './reportsComponents/R26'
import R27 from './reportsComponents/R27'
import R28 from './reportsComponents/R28'
import R29 from './reportsComponents/R29'
import R30 from './reportsComponents/R30'
import R32 from './reportsComponents/R32'
import R33 from './reportsComponents/R33'
import R35 from './reportsComponents/R35'
import R36 from './reportsComponents/R36'

import E01 from './exportersComponents/E01'
import E02 from './exportersComponents/E02'
import E03 from './exportersComponents/E03'
import E04 from './exportersComponents/E04'
import E05 from './exportersComponents/E05'
import E06 from './exportersComponents/E06'
import E07 from './exportersComponents/E07'
import E08 from './exportersComponents/E08'
import E09 from './exportersComponents/E09'

import I01 from './importersComponents/I01'
import I02 from './importersComponents/I02'

import store from 'src/store'
import { wp, ws } from 'src/services'

const ALL_FILTERS = {filters: ['company', 'employer', 'userGroup', 'employee', 'supervisor']}

export const components = {
  R01,
  R02,
  R03,
  R04,
  R05,
  R06,
  R07,
  R08,
  R09,
  R10,
  R11,
  R12,
  R13,
  R14,
  R15,
  R16,
  R17,
  R18,
  R19,
  R20,
  R21,
  R22,
  R23,
  R24,
  R25,
  R26,
  R27,
  R28,
  R29,
  R30,
  R32,
  R33,
  R35,
  R36,
  E01,
  E02,
  E03,
  E04,
  E05,
  E06,
  E07,
  E08,
  E09,
  I01,
  I02
}

export default [
  {
    id: 'R01',
    name: `Espelho/Folha de pontos de todos os ${wp('employee')}`,
    dateSelecion: ['month', 'period'],
    filters: ['company', 'employer', 'userGroup', 'supervisor'],
    description: `Relatório com todos os pontos batidos dos ${wp('employee')} durante o mês`,
    show: true
  },
  {
    id: 'R02',
    name: `Folha de banco de horas de todos os ${wp('employee')}`,
    dateSelecion: ['month'],
    filters: ['company', 'employer', 'userGroup', 'supervisor'],
    description: `Relatório com todos os eventos de banco de horas dos ${wp('employee')} durante o mês`,
    show: store.state.userInfo.compMan.hasWhbank
  },
  {
    id: 'R03',
    name: `Relatório de escalas dos ${wp('employee')}`,
    description: `Relatório com as Jornadas e Escalas cadastradas de cada ${ws('employee')}`,
    show: true
  },
  {
    id: 'R04',
    name: `Apontamento de todos os ${wp('employee')}`,
    dateSelecion: ['period'],
    description: `Relatório com os seguintes apontamentos de todos os ${wp('employee')}: Faltas, Horas extras, ` +
      'Adicional Noturno, Horas extras extraordinárias',
    filters: ['company'],
    show: true
  },
  {
    id: 'R05',
    name: `Planilha de apontamentos de todos os ${wp('employee')}`,
    dateSelecion: ['month'],
    description: `Planilha com os seguintes apontamentos de todos os ${wp('employee')}: Saída Antecipada, Adicional noturno, ` +
      'Horas extra, Horas extra extraordinária, Horas folga trabalhada, Horas feriado trabalhado,' +
      ' Horas extra pausa refeição, Horas extras refeição extraordinária, Horas interjornadas, ' +
      'Horas atraso, Horas trabalhadas, Horas previstas, Horas em faltas, Horas DSR, Horas suspensas,' +
      ' Horas dispensas, Dias trabalhados, Dias trabalhados previstos, Dias dispensas, Faltas, Horas atraso de pausa, ' +
      'Dias sem DSR, Dias suspensos.',
    filters: ['company', 'employer', 'userGroup', 'supervisor'],
    show: true
  },
  {
    id: 'R06',
    name: 'Planilha de apontamentos customizável',
    dateSelecion: ['period'],
    description: `Planilha com os seguintes apontamentos de todos os ${wp('employee')}: Horas de atraso, ` +
      'Horas extra extraordinárias, Horas extra, Horas interjornadas, Horas de atraso de pausa, Adicional noturno, ' +
      'Horas extras refeição extraordinária, horas extras pausa refeição, Horas trabalhadas',
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R07',
    dateSelecion: ['period'],
    name: 'Relatório de marcação de pontos',
    description: 'Relatório com todos os pontos os pontos batidos no período selecionado',
    filters: ['company', 'employer', 'userGroup', 'supervisor'],
    show: true
  },
  {
    id: 'R08',
    name: 'Relatório gerencial',
    dateSelecion: ['period'],
    description: 'Relatório de desempenho dos locais de trabalho com os seguintes apontamentos:' +
      `${wp('employee')} esperados para o trabalho, ${wp('employee')} que registraram pontos, Jornadas com erros de registro,` +
      'Jornadas com horários corretos, Aparelhos não sincronizados, Aparelhos inativos/Aparelhos alocados, Dispensas,' +
      'Suspensões, Observações e declarações, Ocorrências de atrasos,  Ocorrências de saída antecipada,  Ocorrências de' +
      ' hora extra no período,  Ocorrências  de horas extras acima de 2 horas no período,  Dobras constatadas, Faltas não justificadas',
    filters: ['company', 'employer', 'userGroup', 'supervisor'],
    show: true
  },
  {
    id: 'R09',
    name: `Planilha de pontos, apontamentos e informações dos ${wp('employee')}`,
    dateSelecion: ['period'],
    description: 'Planilha com todos os pontos batidos, escalas, locais de trabalho e os seguintes apontamentos por dia:' +
      ' Hora Extra, Hora Extra 100%, Adicional Noturno',
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R10',
    name: 'Planilha com o resumo do banco de horas',
    dateSelecion: ['period'],
    description: 'Planilha com o resumo do banco de horas - total por periodo e total do banco',
    ...ALL_FILTERS,
    show: store.state.userInfo.compMan.hasWhbank
  },
  {
    id: 'R11',
    name: 'Planilha de Horas Extras',
    dateSelecion: ['period'],
    description: 'Planilha de horas extras, horas extras especiais e horas extras extraordinárias. ' +
      'Com informações divididas por dias úteis, sábado e domingo',
    filters: ['company', 'employee'],
    show: true
  },
  {
    id: 'R12',
    name: 'Relatório presencial',
    dateSelecion: ['period'],
    description: `Relatório com porcentagem de pontos batidos no dia por ${ws('employee')}, ou por local de trabalho`,
    filters: ['company', 'employer', 'userGroup', 'supervisor'],
    show: true
  },
  {
    id: 'R13',
    name: `Relatório com informações dos ${wp('employee')}`,
    description: `Relatório com informações cadastrais dos ${wp('employee')} ativos, demitidos ou que tem pontos registrados`,
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R14',
    name: 'Planilha de locais de trabalho',
    dateSelecion: ['period'],
    description: `Planilha que mostra por ${ws('employee')}: Número de outros locais de trabalhos com pontos registrados, ` +
      'Pontos esporádicos em outros locais de trabalho, Quantidade de dias em outros locais de trabalho, Quantidade de' +
      ` dispositivos utilizados, Dias que o ${ws('employee')} bateu ponto em outro local de trabalho, Penúltimo local de ` +
      `trabalho batido, Último local de trabalho batido e Local de trabalho no cadastro do ${ws('employee')}.`,
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R15',
    name: 'Relatório de correção de pontos',
    dateSelecion: ['period'],
    description: 'Relatório com a quantidade de correções de pontos feito no período selecionado e suas descrições, ' +
      `como: Data, Tipo, ${ws('employee')}, Operação, Motivo, Usuário e Correção Automática`,
    filters: ['company', 'employer', 'userGroup', 'supervisor'],
    show: true
  },
  {
    id: 'R16',
    name: 'Relatório de Horas Extras',
    dateSelecion: ['period'],
    description: `Relatório de horas extras por ${ws('employee')} separado por dia e com horários de todos os pontos batidos`,
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R17',
    name: 'Planilha de Afastamentos e Férias',
    dateSelecion: ['period'],
    description: 'Planilha com as seguintes informações sobre os afastamentos e as férias: Data de início, ' +
      'Data do fim, Total de dias e Tipo de jornada durante o afastamento',
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R18',
    name: 'Planilha de benefícios',
    description: 'Planilha para cálculo de benefícios, com: Dias trabalhados, Folgas, Faltas no período anterior, ' +
      'Folgas já trabalhadas e Total dos dias a trabalhar',
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R19',
    name: 'Planilha de Histórico Disciplinar',
    dateSelecion: ['period'],
    description: 'Planilha com o histórico de atestados para dispensas, suspensões e observações',
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R20',
    name: 'Planilha de Pontos batidos fora do local fixo',
    dateSelecion: ['period'],
    description: `Planilha com datas que os ${wp('employee')} bateram fora do local cadastrado`,
    ...ALL_FILTERS,
    show: true
  },
  {
    id: 'R21',
    name: 'Planilha para controle de banco de horas',
    dateSelecion: ['period'],
    description: 'Planilha com histórico de eventos do banco de horas que não tiveram baixa',
    ...ALL_FILTERS,
    show: store.state.userInfo.compMan.hasWhbank
  },
  {
    id: 'R22',
    name: 'Planilha para verificar folhas',
    dateSelecion: ['period'],
    description: 'Planilha com os problemas para ver antes de fechar a folha',
    filters: ['company', 'employer', 'userGroup', 'supervisor'],
    show: true
  },
  {
    id: 'R23',
    name: 'Planilha com o histórico de atividades registradas',
    dateSelecion: ['period'],
    description: 'Planilha com o histórico de atividades registradas',
    filters: ['company', 'employee'],
    show: store.state.userInfo.compMan.hasActivity
  },
  {
    id: 'R24',
    name: 'Planilha com o consolidade de atividades',
    dateSelecion: ['period'],
    description: 'Planilha com o consolidado das atividades',
    filters: ['company', 'employee'],
    show: store.state.userInfo.compMan.hasActivity
  },
  {
    id: 'R25',
    name: 'Planilha de pontos com rosto não reconhecido',
    dateSelecion: ['period'],
    description: 'Planilha de pontos com rosto não reconhecido',
    filters: ['company', 'employee'],
    show: store.state.userInfo.compMan.hasRecognizeFace
  },
  {
    id: 'R26',
    name: 'Relatório de sobreaviso',
    dateSelecion: ['period'],
    description: 'Relatório com os pontos e apontamentos de sobreaviso',
    filters: ['company', 'employer', 'userGroup', 'employee'],
    show: store.state.userInfo.compMan.hasOnCall
  },
  {
    id: 'R27',
    name: 'Relatório de absenteísmo',
    dateSelecion: ['period'],
    description: `Relatório com informações de absenteísmo dos ${wp('employee')}`,
    filters: ['company', 'userGroup', 'employee'],
    show: true
  },
  {
    id: 'R28',
    name: 'Relatório de baixa de banco de horas',
    description: 'Relatório com informações de baixa de banco de horas',
    filters: ['company', 'employee'],
    show: store.state.userInfo.compMan.hasWhbank
  },
  {
    id: 'R29',
    name: 'Relatório de gestão de banco de horas',
    dateSelecion: ['month'],
    description: 'Relatório com informações de gestão de banco de horas',
    filters: ['company', 'employee'],
    show: store.state.userInfo.compMan.hasWhbank
  },
  {
    id: 'R30',
    name: 'Gestão diária de banco de horas',
    dateSelecion: ['month'],
    description: 'Relatório com informações de gestão diária de banco de horas em um determinado mês',
    filters: ['employee'],
    show: store.state.userInfo.compMan.hasWhbank
  },
  {
    id: 'R32',
    name: `Relatório de situação de movimentação de ${ws('employee')}`,
    dateSelecion: ['period'],
    description: `Relatório com informações de situação das movimentações de ${wp('employee')} no periodo`,
    filters: ['company'],
    show: store.state.userInfo.compMan.usePositions
  },
  {
    id: 'R33',
    name: 'Relatório de gerencial',
    dateSelecion: [],
    description: 'Relatório gerencial de movimentações realizadas no dia',
    filters: ['company'],
    show: store.state.userInfo.compMan.usePositions
  },
  {
    id: 'R35',
    name: `Relatório de acompanhamento de ${wp('employee')} - espelhos`,
    dateSelecion: ['period'],
    filters: ['company', 'employee', 'users'],
    description: `Relatório de acompanhamento de status das assinaturas de espelho`,
    show: store.state.userInfo.compMan.hasAprovacaoDeArquivo
  },
  {
    id: 'R36',
    name: `Relatório de histórico de alterações de escalas e jornadas dos empregados`,
    dateSelecion: ['period'],
    filters: ['company', 'employee', 'employer', 'userGroup'],
    description: `Relatório contendo um histórico com todas as alterações nas jornadas (alterações diretas, alterações rápidas, lançamento de dispensa, férias, suspensão, etc) e nas escalas (alteração direta ou através de importação/exportação) dos empregados selecionados, além das informações de data em que ocorreu e usuário que realizou a movimentação.`,
    show: true
  }
]
